var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 173,
    viewBox: "0 0 128 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2402_34263)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 120,
    height: 165,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26,
    width: 52,
    height: 6,
    rx: 3,
    fill: "#C3CFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 86,
    height: 12,
    rx: 6,
    fill: "#E0E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 68,
    width: 86,
    height: 4,
    rx: 2,
    fill: "#E0E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 76,
    width: 86,
    height: 4,
    rx: 2,
    fill: "#E0E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 84,
    width: 86,
    height: 4,
    rx: 2,
    fill: "#E0E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 92,
    width: 86,
    height: 4,
    rx: 2,
    fill: "#E0E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 100,
    width: 52,
    height: 4,
    rx: 2,
    fill: "#E0E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 2.5,
    width: 119,
    height: 164,
    rx: 2.5,
    stroke: "#EDF1F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2402_34263",
    x: 0,
    y: 0,
    width: 128,
    height: 173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.105882 0 0 0 0 0.180392 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2402_34263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2402_34263",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPdf);
export default __webpack_public_path__ + "static/media/job-pdf.f41c4901427baa35e312659744d24415.svg";
export { ForwardRef as ReactComponent };